import { c as _c } from "react/compiler-runtime";
import { MailIcon, PhoneIcon } from '@repo/ui/icons';
import React from 'react';
export const WelcomeModalFooter = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <a className="flex items-center text-gray-700" href="tel:+4401304343434" onClick={_temp}><PhoneIcon className="mr-5 text-transparent" fill="#cd0003" /><span>01304 343434</span></a>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center gap-2 text-center">{t0}<a className="flex items-center text-gray-700" href="mailto:enquiries@$kcharles.co.uk" onClick={_temp2}><MailIcon className="text-brand mr-5" /><span>enquiries@kcharles.co.uk</span></a></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp() {}
function _temp2() {}